import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { NewPasswordComponent } from '../new-password/new-password.component';
import { MainService } from 'src/app/Services/service.service';

@Component({
  selector: 'app-new-password-holder',
  templateUrl: './new-password-holder.component.html',
  styleUrls: ['./new-password-holder.component.scss']
})
export class NewPasswordHolderComponent implements OnInit {

  private code: string;
  constructor(public services: MainService, private route: ActivatedRoute, public dialog: MatDialog) {

    
    this.code = this.route.snapshot.paramMap.get("code");

    const dialogRef = this.dialog.open(NewPasswordComponent, {
      width: "450px",
      disableClose: false,
      data:{code:this.code}
    })

    dialogRef.afterClosed().subscribe(v=>{
 
        this.services.route.navigate([""]);
    
    })

   }

  ngOnInit() {
  }

}
